import { loadProgress } from 'helpers/player';

export function addRecorder(callerScene, datgui) {
  if (datgui && !datgui.__folders?.Recorder) {
    const canvas = document.querySelector('#content canvas');

    window.dev = {
      ...window.dev,
      canvasSize: { width: canvas.width, height: canvas.height },
      clicks: [],
      lastClickTime: 0
    };

    const recorderFuncs = {
      stop: () => {
        if (window.dev.replayActive) {
          window.dev.replayActive = false;
          window.removeEventListener('keyup', replayInfoHandler);
          recorderFolder.name = 'Recorder';
        }
      },
      replay: async lvlData => {
        if (window.dev.replayActive === true) {
          return 'another replay is still active';
        }

        window.dev.replayActive = true;
        window.addEventListener('keyup', replayInfoHandler);

        const { clicks, canvasSize: recordedSize } = JSON.parse(
          lvlData?.trim() ||
            (prompt('Enter previously captured moves', '{}') || '{}').trim()
        );

        if (!clicks || !recordedSize) {
          return `No clicks or no recorderedSize: ${clicks}, ${recordedSize}`;
        }

        window.dev.clicks = clicks;
        const { width, height } = document.querySelector('#content canvas');
        const scene = callerScene.scene;
        async function* replaySteps(clicks) {
          let i = 0;
          for (const step of clicks) {
            if (window.dev.replayActive === false) {
              yield `stopped by user`;
              break;
            }
            i++;
            recorderFolder.name = `Recorder ${i}/${clicks.length}`;

            if (step.type === 'wait') {
              await wait(step.time + 1000);
              yield `waited for: ${step.time} + 1000`;
              continue;
            }
            const { x, y } = step;
            window.dev.currentStep = `${x}/${y}`;
            const cursorSize = document.body.classList.contains('.zoom-3')
              ? { w: 48, h: 54 }
              : document.body.classList.contains('.zoom-2')
              ? { w: 32, h: 36 }
              : { w: 0, h: 0 };
            const newX = (x / recordedSize.width) * width - cursorSize.w;
            const newY = (y / recordedSize.height) * height - cursorSize.h;
            yield await new Promise(async resolve => {
              await poll(
                () => {
                  const debugMarker = document.createElement('div');
                  debugMarker.id = newX + '_' + newY;
                  debugMarker.title = debugMarker.id;
                  debugMarker.classList.add('replay-debug-marker');
                  debugMarker.style = `left: ${newX}px;
                    width: 5px;
                    top: ${newY}px;
                    height: 5px;
                    position: absolute;
                    z-index: 10000;
                    background-color: darkred;`;
                  document.body.appendChild(debugMarker);

                  canvas.dispatchEvent(
                    new MouseEvent('mousedown', {
                      clientX: newX,
                      clientY: newY
                    })
                  );
                  setTimeout(() => {
                    canvas.dispatchEvent(
                      new MouseEvent('mouseup', {
                        clientX: newX,
                        clientY: newY
                      })
                    );
                    resolve(`replayed click at ${newX}/${newY}`);
                  }, 50);
                },
                () => {
                  const dialogueScene = scene.get('DialogueScene');
                  const gameMenuScene = scene.get('GameMenuScene');
                  const worldScene = scene.get('WorldScene');
                  const battleStartTweens = gameMenuScene.tweens.getTweensOf(
                    gameMenuScene.battleStartGfx
                  );

                  const cameraBusy =
                    worldScene.cameras?.main?.panEffect?.isRunning ||
                    worldScene.cameras?.main?.zoomEffect?.isRunning;

                  const loadingMap = worldScene.loadingMap?.active;

                  const worldSceneInCutscene = worldScene.inCutscene;

                  const battleStartAnims = battleStartTweens.some(bst =>
                    bst.isPlaying()
                  );

                  const sceneDisabledInput =
                    scene.isActive() && scene.scene.disableInput === true;

                  const worldDisabledInput =
                    worldScene?.scene?.isActive() &&
                    worldScene?.disableInput === true;

                  const opponentsTurn = gameMenuScene.turnColor === 'red';

                  const busy =
                    cameraBusy ||
                    loadingMap ||
                    battleStartAnims ||
                    (!dialogueScene.scene.isActive() &&
                      (opponentsTurn ||
                        sceneDisabledInput ||
                        worldDisabledInput ||
                        worldSceneInCutscene));

                  console.log('second poll func:', {
                    loadingMap,
                    worldSceneInCutscene,
                    cameraBusy,
                    battleStartAnims,
                    sceneDisabledInput,
                    worldDisabledInput,
                    opponentsTurn,
                    busy
                  });

                  return busy;
                }
              );
            });
          }
        }
        console.log('dev.clicks:', window.dev.clicks);
        for await (const res of replaySteps(window.dev.clicks)) {
          console.log(res);
        }

        window.dev.replayActive = false;
        window.removeEventListener('keyup', replayInfoHandler);
        recorderFolder.name = 'Recorder';
      },
      start: () => {
        window.dev.canvasSize = {
          width: canvas.width,
          height: canvas.height
        };
        const { lastKnownPosition } = loadProgress();
        window.dev.startingLvl = lastKnownPosition;
        canvas.addEventListener('click', recHandler);
        window.addEventListener('command-dispatch', cmdDispatchHandler);
        window.addEventListener('keyup', pauseStepHandler);
      },
      end: () => {
        canvas.removeEventListener('click', recHandler);
        window.removeEventListener('command-dispatch', cmdDispatchHandler);
        window.removeEventListener('keyup', pauseStepHandler);
        console.log('Stored moves: ');
        console.log(
          `%c${JSON.stringify(window.dev)}`,
          'background: #222; color: #bada55'
        );
      },
      clear: () => {
        window.dev.clicks = [];
        Array.from(
          document.querySelectorAll('.replay-debug-marker')
        ).map(child => child.parentElement.removeChild(child));
      }
    };

    const recorderFolder = datgui.addFolder('Recorder');
    recorderFolder.add(recorderFuncs, 'replay');
    recorderFolder.add(recorderFuncs, 'stop');
    recorderFolder.add(recorderFuncs, 'clear');
    recorderFolder.add(recorderFuncs, 'start');
    recorderFolder.add(recorderFuncs, 'end');
    window.dev.recorderFuncs = recorderFuncs;

    return recorderFolder;
  }
}

const recHandler = e => {
  const target = e.target;
  const rect = target.getBoundingClientRect();
  const x = e.clientX - rect.left;
  const y = e.clientY - rect.top;
  let sinceLastClick = 0;
  const now = new Date().getTime();

  if (window.dev.lastClickTime) {
    sinceLastClick = now - window.dev.lastClickTime;
  }

  window.dev.lastClickTime = now;

  if (sinceLastClick) {
    window.dev.clicks.push({ type: 'wait', time: sinceLastClick });
  }

  window.dev.clicks.push({ x, y });
};

const cmdDispatchHandler = e => {
  const { command } = e.detail;
  if (command?.type === 'wait') {
    window.dev.clicks.push(command);
  }
};

const pauseStepHandler = e => {
  if (e.code === 'KeyP') {
    const time = parseInt(prompt('Wait for how long?', 2000), 10) || 2000;
    window.dev.clicks.push({
      type: 'wait',
      time
    });
  }
};

const replayInfoHandler = e => {
  if (e.code === 'KeyI' && window.dev.replayActive) {
    prompt(window.dev.currentStep);
  }
};

const poll = async function(fn, fnCondition, ms) {
  await wait(ms);
  while (fnCondition()) {
    await wait(ms);
  }
  const result = await fn();

  await wait(ms);
  return result;
};

const wait = function(ms = 1000) {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
};
